module.exports = __webpack_public_path__ + "images/banners/category_estimate/banner_category_bulk_56_7d201c91d8cfcb4e007287c66a0d0378.png";